export const giftcardsData = [
    {
      id: 1,
      category: 'Restaurant',
      name: 'Starbucks',
      amount: '$50',
      image: require('./../../images/starbucks_coupon.png'), 
      barcodeImage: require('./../../images/Barcode.png'), 
    },
    {
      id: 2,
      category: 'Restaurant',
      name: 'Tim Hortons',
      amount: '$25',
      image: require('./../../images/timhortons_coupon.png'), 
      barcodeImage: require('./../../images/Barcode.png'), 
    },
    {
      id: 3,
      category: 'Shopping',
      name: 'Amazon',
      amount: '$30',
      image: require('./../../images/amazon_coupon.png'), 
      barcodeImage: require('./../../images/Barcode.png'), 
    },
    {
      id: 4,
      category:'Games',
      name: 'Roblox',
      amount: '$10',
      image: require('./../../images/roblox_coupon.png'), 
      barcodeImage: require('./../../images/Barcode.png'), 
    },
    {
      id: 4,
      category:  'Education',
      name: 'Steam',
      amount: '$5',
      image: require('./../../images/audible.png'),
      barcodeImage: require('./../../images/Barcode.png'), 
    },
    {
      id: 4,
      category:  'PrePaid',
      name: 'Steam',
      amount: '$35',
      image: require('./../../images/visa.png'),
      barcodeImage: require('./../../images/Barcode.png'), 
    },
  ];
  
  export default giftcardsData